// Mock data for Kemp Josef website

export const campInfo = {
  name: "Kemp Josef",
  founded: 2005,
  location: "Dubňany, Důl Josef 829, 696 03",
  phones: ["+420 721 022 279"],
  email: "campjosef@seznam.cz",
  description: "Rodinný kemp s přátelskou atmosférou v malebné vinařské oblasti jižní Moravy. Kompletně oplocený areál s renovovaným sociálním zařízením a novým dětským hřištěm."
};

export const accommodations = [
  {
    id: 1,
    type: "Chatka 1",
    capacity: 12,
    features: ["Voda", "Vytápění", "WiFi", "Lůžkoviny", "Zásuvky"],
    pricePerPerson: 350,
    priceChild: 250
  },
  {
    id: 2,
    type: "Chatka 2",
    rooms: 2,
    capacityPerRoom: 9,
    features: ["Samostatné vchody", "Voda", "Vytápění", "WiFi", "Lůžkoviny"],
    pricePerPerson: 350,
    priceChild: 250
  },
  {
    id: 3,
    type: "Stany",
    capacity: 50,
    price: 130,
    unit: "stan/den"
  },
  {
    id: 4,
    type: "Karavany & Obytná auta",
    capacity: 20,
    features: ["Elektrické přípojky", "Přípojky vody", "Výlevky pro chemické WC"],
    price: 250,
    unit: "karavan/den"
  }
];

export const pricing = [
  { item: "Dospělá osoba", price: 150, unit: "Kč/den" },
  { item: "Dítě", price: 100, unit: "Kč/den" },
  { item: "Stan", price: 130, unit: "Kč/den" },
  { item: "Auto", price: 100, unit: "Kč/den" },
  { item: "Motorka", price: 90, unit: "Kč/den" },
  { item: "Karavan", price: 250, unit: "Kč/den" },
  { item: "Elektřina", price: 100, unit: "Kč/den" },
  { item: "Zvíře", price: 100, unit: "Kč/den" },
  { item: "Ubytování v chatce", price: 350, unit: "Kč/os/den" },
  { item: "Dítě v chatce (do 15 let)", price: 250, unit: "Kč/os/den" },
  { item: "Rekreační poplatek", price: 50, unit: "Kč/den" }
];

export const facilities = [
  {
    category: "Pro děti",
    items: ["Nové dětské hřiště", "Skluzavky", "Houpačky", "Pískoviště"]
  },
  {
    category: "Koupání",
    items: ["Bazén v areálu", "Veřejné koupaliště s tobogánem (2 km)"]
  },
  {
    category: "Sport & Zábava",
    items: ["Stolní tenis", "Petanque", "Minikopaná", "Ohniště s možností zapůjčení grilu", "Pódium pro hudební akce"]
  },
  {
    category: "Technické zázemí",
    items: ["WiFi s výborným signálem", "Společná kuchyňka", "Pračka", "Parkoviště", "Služba 24h denně"]
  },
  {
    category: "Ostatní",
    items: ["Domácí mazlíčci povoleni"]
  }
];

export const attractions = [
  "Cyklostezky (směr Hodonín, Kyjov)",
  "Zámek Milotice",
  "Zoo Hodonín",
  "Muzeum naftového dobývání",
  "Přístaviště Hodonín (plavba po Moravě)",
  "Vinné sklípky a folklorní tradice Slovácka"
];

export const targetGroups = [
  "Soukromé oslavy a svatby",
  "Školní výlety a sportovní soustředění",
  "Firemní večírky a školení",
  "Srazy (motorkářské, autokluby atd.)",
  "Hudební produkce"
];

export const foodImages = [
  "https://i.ibb.co/HLbPNzm3/IMG-20260408-WA0036.jpg",
  "https://i.ibb.co/ZR6Lssg5/IMG-20260408-WA0037.jpg",
  "https://i.ibb.co/HD8bTV0p/IMG-20260408-WA0038.jpg",
  "https://i.ibb.co/JwvR2CyZ/IMG-20260408-WA0039.jpg",
  "https://i.ibb.co/93sWSxYj/Sn-mek-obrazovky-2026-04-11-184713.png",
  "https://i.ibb.co/whGYNzs3/Sn-mek-obrazovky-2026-04-11-184719.png",
  "https://i.ibb.co/b5KG2g9C/b777e786-97b1-4138-862b-92a114c8bdae.jpg",
  "https://i.ibb.co/jZfT4yjX/dd348e08-b28d-4034-b2b9-c5cf86d46ef3.jpg",
  "https://i.ibb.co/nqF0cDqw/8664b92c-2460-45bd-ab7c-5425d40ad7aa.jpg",
  "https://i.ibb.co/Y7fZgR5X/ee8f3d13-d6ab-4e93-987e-dbe96550330e.jpg"
];

export const campImages = [
  "https://i.ibb.co/spg67QP0/IMG-20260408-WA0000.jpg",
  "https://i.ibb.co/Ndfr9yhq/IMG-20260408-WA0001.jpg",
  "https://i.ibb.co/Jw2PdwVY/IMG-20260408-WA0002.jpg",
  "https://i.ibb.co/C3XNJX1K/IMG-20260408-WA0003.jpg",
  "https://i.ibb.co/39Nc2B3t/IMG-20260408-WA0004.jpg",
  "https://i.ibb.co/cnw8Wrp/IMG-20260408-WA0005.jpg",
  "https://i.ibb.co/5gCbPX6c/IMG-20260408-WA0006.jpg",
  "https://i.ibb.co/20Q2V7CD/IMG-20260408-WA0007.jpg",
  "https://i.ibb.co/cK0ygr2r/IMG-20260408-WA0008.jpg",
  "https://i.ibb.co/Wp7MRPnc/IMG-20260408-WA0009.jpg",
  "https://i.ibb.co/m3rRG3p/IMG-20260408-WA0010.jpg",
  "https://i.ibb.co/zVMLkw6c/IMG-20260408-WA0011.jpg",
  "https://i.ibb.co/xthHmZ0N/IMG-20260408-WA0012.jpg",
  "https://i.ibb.co/3Y4T7m51/IMG-20260408-WA0013.jpg",
  "https://i.ibb.co/PGDmPGrj/IMG-20260408-WA0014.jpg",
  "https://i.ibb.co/Tz43QBb/IMG-20260408-WA0015.jpg",
  "https://i.ibb.co/qMN6kyP0/IMG-20260408-WA0016.jpg",
  "https://i.ibb.co/Y4XnPkMv/IMG-20260408-WA0017.jpg",
  "https://i.ibb.co/hxmNdBqP/IMG-20260408-WA0019.jpg",
  "https://i.ibb.co/TxC9xxWk/IMG-20260408-WA0020.jpg",
  "https://i.ibb.co/jv6bMTQN/IMG-20260408-WA0021.jpg",
  "https://i.ibb.co/SDJfgP53/IMG-20260408-WA0022.jpg",
  "https://i.ibb.co/C3gHWgc0/IMG-20260408-WA0023.jpg",
  "https://i.ibb.co/qLdQVTFR/IMG-20260408-WA0034.jpg",
  "https://i.ibb.co/FpdCHXt/IMG-20260408-WA0035.jpg"
];
